"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _EditAccessoryComponent = _interopRequireDefault(require("../components/EditAccessoryComponent"));
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _Services = require("../common_features/utility/Services");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _lodash = _interopRequireDefault(require("lodash"));
var _systemsReducer = require("../common_features/redux/reducers/systemsReducer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const EditFilter = () => {
  const {
    selectedAccessory
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const {
    selectedSystems
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const [warningModal, setWarningModal] = (0, _react.useState)(false);
  const [errorModal, setErrorModal] = (0, _react.useState)(false);
  const [saveErrorModal, setSaveErrorModal] = (0, _react.useState)(false);
  const [value, setValue] = (0, _react.useState)("");
  const [isUpdating, setIsUpdating] = (0, _react.useState)(false);
  const [inputValue, setInputValue] = (0, _react.useState)(selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.selectedRefAppLife);
  const location = (0, _reactRouterDom.useLocation)();
  const initialDate = new Date(selectedAccessory.refAppInstallationDate);
  const dispatch = (0, _reactRedux.useDispatch)();
  const navigate = (0, _reactRouterDom.useNavigate)();
  const isPartial = selectedSystems.isComplete;
  const handleInputValue = value => {
    setInputValue(value);
  };
  const dateChange = date => {
    setValue(date);
  };
  const handleBack = () => {
    navigate(-1);
  };
  const handleSaveBtn = async () => {
    setIsUpdating(true);
    setErrorModal(false);
    setSaveErrorModal(false);
    let systemDate = new Date(value).toISOString();
    dispatch((0, _systemsReducer.accessorySelected)({
      ...selectedAccessory,
      refAppInstallationDate: new Date(systemDate).toISOString()
    }));
    const data = {
      orgId: selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.orgId,
      systemId: selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.systemId,
      systemReferences: [{
        refAppId: selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppId,
        refAppInstallationDate: systemDate,
        selectedRefAppLife: inputValue,
        refAppName: selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppName,
        refAppType: selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppType
      }]
    };
    setIsUpdating(false);
    dispatch((0, _systemsReducer.imageData)([]));
    navigate(_RoutePath.default.imageUpload.useLink, {
      state: {
        fromScreen: 'editFilter',
        filterDetail: {
          ...selectedAccessory,
          refAppInstallationDate: new Date(systemDate).toISOString()
        },
        navHeading: 'Edit Filter',
        changesFlag: !_lodash.default.isEqual(new Date(initialDate).toISOString(), new Date(value).toISOString()),
        refAppId: selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppId
      }
    });
  };
  const getSliderValue = val => {
    if (val % 2 === 0) {
      return val / 2;
    } else {
      return Math.floor(val / 2);
    }
  };
  (0, _react.useEffect)(() => {
    if (!value && selectedAccessory) {
      setValue(new Date(selectedAccessory.refAppInstallationDate));
    }
  }, [value, selectedAccessory]);
  return /*#__PURE__*/_react.default.createElement(_EditAccessoryComponent.default, {
    handleBack: handleBack,
    leftArrow: _index.default.leftArrow.default,
    backNavigationScreen: "System Dashboard",
    headerText: "Edit Filter",
    pname: "".concat(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemModelNumber, ">").concat(selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppName, ">").concat(selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppModelNumber),
    inputLabel: "Installation  Date",
    dateChange: dateChange,
    saveBtnTitle: "Continue",
    saveBtnClick: handleSaveBtn,
    saveBtnDisabled: false,
    removeSensorButtonText: "Replace with a New Filter",
    removeBtnDisabled: true,
    edit: true,
    warningModal: warningModal,
    value: value,
    handleInputValue: handleInputValue,
    inputValue: inputValue,
    editSliderLabel: "Recommended replacement duration:",
    isUpdating: isUpdating,
    errorModal: errorModal,
    saveErrorModal: saveErrorModal,
    sliderMin: 1,
    sliderMax: getSliderValue(selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppLife),
    inputNumberMin: 1,
    inputNumberMax: getSliderValue(selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppLife),
    sliderLeftText: "1 mo.",
    sliderRightText: getSliderValue(selectedAccessory === null || selectedAccessory === void 0 ? void 0 : selectedAccessory.refAppLife) + " mos.",
    maxInstallationDate: new Date(),
    minInstallationDate: new Date(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.installedDate),
    pageNumberNotShow: true,
    isPartial: isPartial,
    rightNavHeading: 'Cancel',
    handleCancle: handleBack
  });
};
var _default = exports.default = EditFilter;